import {
  Alert,
  Box,
  Button,
  Paper,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import {
  useGetBureauAdminsQuery,
  useAttachAdminToBureauMutation,
  useDetachAdminFromBureauMutation,
} from "../../app/services/bureauApi";
import DetachAdminButton from "./DetachAdminButton";
import AttachAdminModal from "./AttachAdminModal";

function ListAdminBureau({ bureauId }) {
  const {
    data: admins,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetBureauAdminsQuery(bureauId);

  const [attachAdmin] = useAttachAdminToBureauMutation();
  const [detachAdmin] = useDetachAdminFromBureauMutation();
  const [openModal, setOpenModal] = useState(false);

  const handleAttach = async (userId) => {
    await attachAdmin({ bureauId, userId });
    refetch();
  };

  const handleDetach = async (userId) => {
    await detachAdmin({ bureauId, userId });
    refetch();
  };

  return (
    <div>
      <h3>Administrateurs associés au bureau</h3>

      <Box
        sx={{
          backgroundColor: "white",
          padding: 2,
          borderRadius: 4,
          mb: 2,
        }}
      >
        <Button variant="contained" onClick={() => setOpenModal(true)}>
          Ajouter un administrateur
        </Button>
      </Box>

      <Box sx={{ backgroundColor: "white", padding: 2, borderRadius: 4 }}>
        {isLoading ? (
          <CircularProgress />
        ) : isError ? (
          <Alert severity="error">
            Une erreur est survenue lors du chargement des administrateurs :{" "}
            {error.message}
          </Alert>
        ) : (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="admin list table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Nom</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Date d'inscription
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {admins?.map((admin) => (
                  <TableRow key={admin.id}>
                    <TableCell>{admin.id}</TableCell>
                    <TableCell>{admin.name}</TableCell>
                    <TableCell>{admin.email}</TableCell>
                    <TableCell>
                      {new Date(admin.created_at).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <DetachAdminButton
                        userId={admin.id}
                        bureauId={bureauId}
                        detachAdmin={detachAdmin}
                        refetch={refetch}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      <AttachAdminModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onAttach={handleAttach}
      />
    </div>
  );
}
export default ListAdminBureau;
